import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faDollarSign, faReceipt, faTags, faFile, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router";
import CatalogosEtiquetasModal from "./CatalogosEtiquetasModal";
import { actions as actionSite } from "./../../../redux/actions/site";
import { useDispatch } from "react-redux";
import "./Listagem.scss";
import RelatoriosModal from "./RelatoriosModal";

const Listagem = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [paramsSearch, setParamsSearch] = useState("");
  const total = props.registros.total;

  const setAcao = (acao, id) => {
    let rota = `/painel/${props.rota}/${acao}`;
    if (id) {
      rota += `/${id}`;
    }
    history.push(rota);
  };

  const showCatalogosEtiquetas = async (obj) => {
    const configModal = {
      msg: "",
      component: <CatalogosEtiquetasModal campanha={obj} />,
      title: `Escolha um catálogo`,
    };

    dispatch(actionSite.setModal(configModal));
  };

  const relatorio = async (obj) => {
    const configModal = {
      msg: "",
      component: <RelatoriosModal campanha={obj} />,
      title: `Relatórios`,
    };

    dispatch(actionSite.setModal(configModal));
  };

	const renderItems = () => {
    if (props.loadingList) {
      return (
        <tr>
          <td colSpan={props.config.columns.length + 2}>Carregando listagem...</td>
        </tr>
      );
    }
    if (props.registros.rows.length > 0) {
      return props.registros.rows.map((ele, index) => {
        return (
          <tr key={index} id={ele._id} draggable={props.config.sort === "ordem"}>
            {renderColumnsItems(ele)}
            <td className="acoes">
              <button
                className="edit"
                onClick={() => {
                  setAcao("form", ele._id);
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                className="status"
                onClick={() => {
                  setAcao("boletos", ele._id);
                }}
              >
                <FontAwesomeIcon icon={faDollarSign} /> B
              </button>
              <button
                className="warning"
                onClick={() => {
                  setAcao("faturas", ele._id);
                }}
              >
                <FontAwesomeIcon icon={faReceipt} /> F
              </button>
              <button
                className="neutral"
                onClick={() => {
                  showCatalogosEtiquetas(ele);
                }}
              >
                <FontAwesomeIcon icon={faTags} /> E
              </button>

              <button
                className="default"
                onClick={() => {
                  relatorio(ele);
                }}
              >
                <FontAwesomeIcon icon={faFileAlt} /> R
              </button>

            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan={props.config.columns.length + 2}>Nenhum registro encontrado</td>
        </tr>
      );
    }
  };

  const renderTitles = () => {
    const thead = (
      <tr>
        {renderColumns()}
        <td width="400">Ações</td>
      </tr>
    );
    return thead;
  };

  const renderColumns = () => {
    return props.config.columns.map((c, i) => {
      return <td key={i}>{c.label}</td>;
    });
  };

  const converts = {
    toSimNao: (s) => {
      return s ? "Sim" : "Não";
    },
  };

  const renderColumnsItems = (row) => {
    return props.config.columns.map((c, i) => {
      const cls = c.field === "ordem" ? "order" : "";
      return (
        <React.Fragment key={i}>
          <td className={cls} width={c.width || ""}>
            {renderValue(row, c)}
          </td>
        </React.Fragment>
      );
    });
  };

  const renderValue = (row, c) => {
    let value = row[c.field];

    if (c.field.includes(".")) {
      value = eval(`row.${c.field}`);
    }

    if (c.filter) {
      const filtrado = row[c.filter.field].find((e) => e[c.filter.condition.field] === c.filter.condition.value);
      if (filtrado) {
        value = filtrado[c.field];
      }
    }

    if (c.convert) {
      if (typeof c.convert === "string") {
        return converts[c.convert](value);
      } else if (typeof c.convert === "function") {
        return c.convert(value);
      }
    }

    return value;
  };

  return (
    <>
      <div className="crudView">
        <div className="gridView">
          <table cellPadding="0" cellSpacing="0">
            <thead>{renderTitles()}</thead>
            <tbody>{renderItems()}</tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Listagem;
